@if(showTitle){
    <div class="headerContainer">
    <header [ngClass]="(props && props.istitleCenter) ? 'panelHeaderCenter' : 'panel-header'">{{ dynamicFormArray.title }}</header>
    @if(dynamicFormArray && dynamicFormArray.isCloseIcon){
    <button class="close-btn" (click)="closeBtnOnClick($event)"><i class="fa-solid fa-xmark"></i></button>
    }
    </div>

}
@if(props && props.isBreadCrumbSection){
      <app-breadcrums [breadcrumList]="breadcrumList"></app-breadcrums>
}
<app-form-container  class="form-container" [dynamicFormArray]="dynamicFormArray" [props]="props"  [DataTableSchema]="DataTableSchema"></app-form-container>
